import { ThemeProvider } from '@/components/health-ui';
import { AuthErrorBoundary, AuthProvider } from '@platform/keycloak-react-auth';
import { RouterProvider } from '@tanstack/react-router';

import ApiProvider from '@/providers/api-provider';
import { AuthLoading } from '@/components/auth-loading';
import { AuthUnavailable } from '@/components/auth-unavailable';
import { PrincipalGate } from '@/components/principal-gate';
import { ApplicationAccessGate } from '@/components/application-access-gate';
import { ProviderCapabilitiesGate } from '@/components/provider-capabilities-gate';
import { keycloak } from '@/lib/auth-guards';
import router from '@/lib/router';

const AppProvider = (): React.JSX.Element => {
  return (
    <ThemeProvider defaultTheme="system" storageKey="ow-theme">
      <AuthErrorBoundary
        fallback={() => (
          <AuthUnavailable onRetry={() => window.location.reload()} />
        )}
      >
        <AuthProvider
          instance={keycloak}
          onLoad="login-required"
          initOptions={{ redirectUri: window.location.origin }}
          loadingFallback={<AuthLoading />}
        >
          <PrincipalGate>
            <ApiProvider>
              <ProviderCapabilitiesGate>
                <ApplicationAccessGate>
                  <RouterProvider router={router} />
                </ApplicationAccessGate>
              </ProviderCapabilitiesGate>
            </ApiProvider>
          </PrincipalGate>
        </AuthProvider>
      </AuthErrorBoundary>
    </ThemeProvider>
  );
};

export default AppProvider;
